<template>
  <div class="borderR contentBox slideBar" ref="width">
    <el-menu
      v-if="routes.length > 0"
      ref="menu"
      mode="vertical"
      :default-active="$route.path"
      text-color="#fff"
      :collapse="isCollapse"
      class="el-menu-vertical-demo"
      :unique-opened="true"
      >
      <div class="clearfix"></div>
      <template v-for="(item,index) in routes">
        <div
          v-if="(item.children&&item.children.length===0)"
          :to="item.path"
          :key="item.name"
          @click="goTo(item)"
        >
          <el-menu-item :index="item.path" class="submenu-title-noDropdown">
            <svg-icon  :iconClass="item.icon && item.icon!='' ? item.icon :'file'" class="labelImg f20"></svg-icon>

            <span slot="title" class="ml8">{{item.name}}</span>
          </el-menu-item>
        </div>
        <template v-if="item.children">
          <template v-if="item.isOnly">
            <div :to="item.children[0].path"  @click="goTo(item.children[0])" v-if="!item.meta||item.meta.isShow!=false" :key="item.name">
              <el-menu-item :index="item.children[0].path" class="submenu-title-noDropdown">
                <svg-icon  :iconClass="item.icon && item.icon!='' ? item.icon :'file'" class="labelImg f20"></svg-icon>
                <span slot="title" v-if="item.children[0].name.length < 8" class="ml8">{{item.children[0].name}}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.children[0].name"
                  placement="top-start"
                  v-else
                >
                  <span>{{item.children[0].name}}</span>
                </el-tooltip>
              </el-menu-item>
            </div>
          </template>
          <el-submenu v-else :key="item.name" :index="index.toString()">
            <template slot="title">
              <svg-icon  :iconClass="item.icon && item.icon!='' ? item.icon :'file'" class="labelImg f20"></svg-icon>
              <span slot="title" v-if="item.name.length < 6" class="ml8">{{item.name}}</span>
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.name"
                placement="top-start"
                v-else
              >
                <span class="ml8">{{item.name}}</span>
              </el-tooltip>
            </template>
            <menutree :data="item.children"></menutree>
          </el-submenu>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import menutree from './menutree';
    export default {
        computed: {
            ...mapGetters(['menu'])
        },
        props:['routes'],
        data() {
            return{
                opened: false,
                isCollapse:false,
            }
        },
        components: { menutree},
        methods: {
            toClick() {
                this.isCollapse = !this.isCollapse;
            },
            goTo(item){
              // 判断跳转的页面是否为当前页面，如果为当前页面，则不进行跳转
              // if(this.$route.path!=item.path){
                this.$store.commit("SET_PATH", item.path);
                this.$router.push({path:item.path})
              // }
            },
        },
        mounted() {
            // this.routes =  [...new Set(this.$router.options.routes)];
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-submenu {
  /deep/ {
    .el-menu.el-menu--inline {
      background-color: #4c7ee9;
    }
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 190px;
  min-height: 400px;
}
.top-menu {
  border-bottom: 1px solid #e7e7e7;
  background: #272c33;
}
.leftpanel-title {
  text-transform: uppercase;
  color: #ccc;
  font-size: 11px;
  font-weight: normal;
  margin: 15px 15px;
}
.hamburger {
  float: right;
  color: #428bca;
  margin-top: 10px;
  margin-right: 20px;
}
.el-menu {
  background: #4c7ee9;
  /deep/ {
    height: 100%;
    border: 0px solid transparent !important;
    .el-menu-item:focus,
    .el-menu-item:hover {
      background: #3967cb;
      // background: rgba(255, 255, 255, 0.15);
      color: #fff !important;
      .labelImg {
        color: #fff;
        // color:rgba(3,130,255,1);;
      }
    }

    .router-link-active {
      .el-menu-item {
        background: #3967cb;
        color: #fff !important;
        // border-right: 6px solid rgba(255, 174, 51, 1)
      }
    }
    .el-menu-item,
    .el-menu-item {
      // background: #333A43;
      color: #d7e0f4 !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 48px;
      line-height: 48px;
      min-width: 190px;
    }
    .el-submenu__title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 48px;
      line-height: 48px;
      color: #d7e0f4 !important;
      i {
        color: #ffffff;
      }
      // .labelImg{
      //     color:#666C72;
      // }
      &:hover {
        background: #3967cb;
        //    background: rgba(255, 255, 255, 0.15);
        color: #fff !important;

        // color:white!important;
        i {
          color: #fff;
        }
        .labelImg {
          color: #fff;
        }
      }
    }
    .el-menu-item.is-active {
      background: #3967cb;
        color: #fff !important;
    }
  }
}
/deep/.el-menu--collapse.el-menu{
     .el-submenu__title {
      overflow: hidden;
      text-overflow: initial!important;
      white-space: nowrap;
    }
    .el-menu-item{
      min-width: 64px;
    }
  }

.slideBar {
  position: relative;
  background: #4c7ee9;
  z-index: 100;
}
.slideBar {
  /deep/ {
    .el-submenu.is-opened {
      .el-menu-item {
        // padding-left: 60px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 10px;
      }
    }
  }
}
.el-menu--popup-right-start {
  /deep/ {
    li {
      color: black;
    }
  }
}
.ml8 {
    margin-left: 8px;
}

.svg-icon {
    margin-right: 0px!important;
}
</style>
